// ======================================================================
// File Name       : ContentQuestionListContainer
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import $ from 'jquery';
import React, { Component } from 'react';
import { Field, reduxForm, isInvalid, getFormValues, change, formValueSelector } from 'redux-form';
import { connect } from 'react-redux';
import { Button, Col } from 'react-bootstrap';
import ContentQuestionSearch from '../../components/content/ContentQuestionSearch';
import ContentQuestionList from '../../components/content/ContentQuestionList';
import DialogConfirm from '../../components/DialogConfirm';
import * as ContentQuestionAction from '../../actions/content/ContentQuestionAction';
import * as MessageTemplate from '../../constants/MessageTemplate';
import { DATA_AFFIILIATION_TYPE, CONTENT_QUESTION_KIND } from '../../constants/ContentConstant';
import {
  VALIDATE_TYPE,
  RETURN_MAX_NUM,
  NUM_ATTRIBUTE_QUESTION_SEARCH,
  NUM_ATTRIBUTE_QUESTION_SEARCH_MAX,
  PREVIEW_EACH_QUESTION_ATTRIBUTE_NAME,
} from '../../constants/index';
import RenderField from '../../utils/ReduxFormUtils';
import { showExportCSVSuccessMessage } from '../../utils/index';
import Header from '../../components/Header';
import MessageSearch from '../../components/MessageSearch';
import {
  CONTENT_QUESTION_DETAIL,
  CONTENT_QUESTION_LIST,
  PREVIEW_EACH_QUESTION_ATTRIBUTE,
} from '../../constants/PathConstants';
import * as actionType from '../../constants/actionTypes/page';
import CustomLink from '../../components/button/CustomLink';
import * as Path from '../../constants/PathConstants';
import * as ICON from '../../constants/IconConstants';

class ContentQuestionListContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      filterData: {},
      showExportModal: false,
      isAllowShowSearchMessage: false,
      isClosed: true,
      buttonText: 'plus',
      number: NUM_ATTRIBUTE_QUESTION_SEARCH,
    };

    this.handleInputChange = this.handleInputChange.bind(this);
    this.searchData = this.searchData.bind(this);
    this.handleSortState = this.handleSortState.bind(this);
    this.onExportDialogCancel = this.onExportDialogCancel.bind(this);
    this.onExportDialogOk = this.onExportDialogOk.bind(this);
    this.getStartEndData = this.getStartEndData.bind(this);
    this.goToDetail = this.goToDetail.bind(this);
    this.createParams = this.createParams.bind(this);
    this.initData = this.initData.bind(this);
    this.dismissMessage = this.dismissMessage.bind(this);
    this.clickSearchButton = this.clickSearchButton.bind(this);
    this.searchData = this.searchData.bind(this);
    this.openOrCloseAttributeArea = this.openOrCloseAttributeArea.bind(this);
    this.handleChangeOption = this.handleChangeOption.bind(this);
    this.openPreviewEachQuestionAttribute = this.openPreviewEachQuestionAttribute.bind(this);
    this.addAttribute = this.addAttribute.bind(this);
    this.removeAttributeSearch = this.removeAttributeSearch.bind(this);
    this.handleMouseEnter = this.handleMouseEnter.bind(this);
    this.handleMouseLeave = this.handleMouseLeave.bind(this);
  }

  componentWillMount() {
    const { searchCondition, initialValues } = this.props;
    const filterData = {
      ...this.state,
      filterData: searchCondition,
    };
    this.initData();
    let number = this.state.number;
    let attributeOptions = {};
    if (initialValues && initialValues.attributeOptions) {
      attributeOptions = initialValues.attributeOptions;
    }
    const attributeList = [];
    const attributeListAll = [];
    for (let i = 1; i <= NUM_ATTRIBUTE_QUESTION_SEARCH_MAX; i++) {
      attributeListAll.push(`attribute${i}`);
    }
    let isClosed = this.state.isClosed;
    let buttonText = this.state.buttonText;

    attributeListAll.forEach((element, index) => {
      if (element && attributeOptions && attributeOptions[element]) {
        if (index >= NUM_ATTRIBUTE_QUESTION_SEARCH) {
          number = searchCondition && searchCondition.number ? searchCondition.number : number;
        }
        isClosed = false;
        buttonText = 'minute';
      }
    });
    const cachedIframe = $('.cached_question_skin');
    if (!(cachedIframe && cachedIframe.length)) {
      ContentQuestionAction.cachePreviewQuestionSkin();
    }
    this.setState({ isClosed, buttonText, number, filterData });
  }

  initData() {
    const { initialValues } = this.props;
    let column = null;
    let startPosition = 0;
    if (initialValues) {
      if (initialValues.questionSortType) {
        column = initialValues.questionSortType;
      }
      if (initialValues.startPosition) {
        startPosition = initialValues.startPosition;
      }
    }
    if (initialValues.attributeOptions && initialValues.attributeText) {
      initialValues.questionAttributeId = initialValues.attributeOptions;
      initialValues.eachQuestionAttributeName = initialValues.attributeText;
    }
    const param = this.createParams(initialValues, column, startPosition);
    this.props.dispatch(ContentQuestionAction.initContentList(param));
    this.props.dispatch(ContentQuestionAction.createValueAttributeItem());
    this.props.dispatch(ContentQuestionAction.getAttributeQuestionList());
  }

  handleChangeOption(value, name) {
    const { dispatch, formValues } = this.props;
    let attributeText = {};
    let attributeOptions = {};
    if (formValues && formValues.attributeText) {
      attributeText = formValues.attributeText;
    }
    if (formValues && formValues.attributeOptions) {
      attributeOptions = formValues.attributeOptions;
    }
    const attrArray = Object.keys(attributeOptions);
    attrArray.forEach((element) => {
      if (element && `attributeOptions.${element}` === name) {
        if (!value) {
          attributeText[element] = '';
          this.props.dispatch(
            change('contentQuestionList', `attributeText.${element}`, attributeText[element]),
          );
        }
      }
    });
  }

  goToDetail(questionSecernId) {
    const { invalid, formValues } = this.props;
    formValues.number = this.state.number;
    if (!invalid) {
      this.props.dispatch({
        type: actionType.SAVE_SEARCH_CONDITION,
        parentPath: CONTENT_QUESTION_LIST,
        searchCondition: formValues,
      });
    }
    const path = CONTENT_QUESTION_DETAIL.replace(':id', questionSecernId);
    this.props.history.push(path);
  }

  componentWillUnmount() {
    const { formValues } = this.props;
    this.props.dispatch({
      type: actionType.SAVE_SEARCH_CONDITION,
      parentPath: CONTENT_QUESTION_LIST,
      searchCondition: formValues,
    });
  }

  clickSearchButton() {
    const { dispatch, formValues, invalid } = this.props;
    if (invalid) {
      return;
    }
    const filterData = {
      ...this.state.filterData,
      questionSecernId: formValues.questionSecernId,
      questionTitle: formValues.questionTitle,
      answerFormula: formValues.answerFormula,
      convertStatus: formValues.convertStatus,
      createdDateFrom: formValues.createdDateFrom,
      createdDateTo: formValues.createdDateTo,
      dataAffiliationType: formValues.dataAffiliationType,
      questionKind: formValues.questionKind,
      startPosition: formValues.startPosition,
      questionSortType: formValues.questionSortType,
      ascendingDescendingSort: formValues.ascendingDescendingSort,
      questionAttributeId: formValues.attributeOptions,
      eachQuestionAttributeName: formValues.attributeText,
      createdUserName: formValues.createdUserName, // Step 9.0.0
    };
    this.setState({ filterData }, () => {
      const paramSearch = this.createParams(filterData, null, 0);
      this.props.change('startPosition', 0);
      this.props.change('questionSortType', null);
      this.props.change('ascendingDescendingSort', null);
      this.props.dispatch(ContentQuestionAction.searchContent(paramSearch)).then(() => {
        this.setState({ isAllowShowSearchMessage: true });
      });
    });
  }

  openOrCloseAttributeArea() {
    this.setState({
      isClosed: !this.state.isClosed,
      buttonText: this.state.isClosed ? 'minute' : 'plus',
    });
  }

  createParams(data, column, startPosition) {
    const param = { ...data };
    if (!isNaN(parseInt(startPosition, 10))) {
      param.startPosition = startPosition;
    }

    if (column && Object.keys(column).length) {
      param.ascendingDescendingSort = column.sortState;
      param.questionSortType = column.sortBy;
    }
    if (!column) {
      param.ascendingDescendingSort = null;
      param.questionSortType = null;
    }

    if (!startPosition) {
      param.startPosition = 0;
    }
    if (data.questionAttributeId || (data.questionAttributeId && data.eachQuestionAttributeName)) {
      const questionAttributeList = [];
      let attributeText = {};
      let attributeOptions = {};
      if (data.eachQuestionAttributeName) {
        attributeText = data.eachQuestionAttributeName;
      }
      if (data.questionAttributeId) {
        attributeOptions = data.questionAttributeId;
      }
      const attrArray = Object.keys(attributeOptions);
      attrArray.forEach((element) => {
        if (element && attributeOptions[element]) {
          const attrArrayObj = {
            questionAttributeId: attributeOptions[element],
            eachQuestionAttributeName: attributeText[element],
          };
          questionAttributeList.push(attrArrayObj);
        }
      });
      param.questionAttributeList = questionAttributeList;
    }
    return param;
  }

  searchData(startPosition, column) {
    const { formValues, invalid, dispatch } = this.props;
    const { filterData } = this.state;
    if (invalid) {
      return;
    }
    const paramSearch = this.createParams(filterData, column, startPosition);
    this.props.dispatch(ContentQuestionAction.searchContent(paramSearch)).then(() => {
      this.setState({ isAllowShowSearchMessage: true });
    });
  }

  handleInputChange(name, value) {
    const filterData = { ...this.state.filterData, ...{ [name]: value } };
    this.setState({
      filterData,
    });
  }

  getStartEndData(startPosition) {
    const { invalid, formValues } = this.props;
    if (invalid) return;
    let column = null;
    if (formValues.questionSortType) {
      column = formValues.questionSortType;
    }
    this.searchData(startPosition, column);
  }

  handleSortState(column) {
    const { invalid, formValues } = this.props;
    if (invalid) return;
    let startPosition = null;
    if (formValues.startPosition) {
      startPosition = formValues.startPosition;
    }
    this.searchData(startPosition, column);
  }

  openExportDialog(mdContent, mdSize) {
    this.content = mdContent;
    this.mdSize = mdSize;
    this.setState({ showExportModal: true });
  }

  openPreviewEachQuestionAttribute() {
    const newWindows = window.open(PREVIEW_EACH_QUESTION_ATTRIBUTE, PREVIEW_EACH_QUESTION_ATTRIBUTE_NAME, 'height=750,width=850');
    newWindows.focus();
  }

  onExportDialogCancel() {
    this.setState({ showExportModal: false });
  }

  onExportDialogOk() {
    const { filterData } = this.state;
    if (filterData && filterData.questionAttributeId && filterData.eachQuestionAttributeName) {
      const questionAttributeList = [];
      let attributeText = {};
      let attributeOptions = {};
      if (filterData.eachQuestionAttributeName) {
        attributeText = filterData.eachQuestionAttributeName;
      }
      if (filterData.questionAttributeId) {
        attributeOptions = filterData.questionAttributeId;
      }
      const attrArray = Object.keys(attributeOptions);
      attrArray.forEach((element) => {
        if (element && attributeOptions[element]) {
          const attrArrayObj = {
            questionAttributeId: attributeOptions[element],
            eachQuestionAttributeName: attributeText[element],
          };
          questionAttributeList.push(attrArrayObj);
        }
      });
      filterData.questionAttributeList = questionAttributeList;
    }
    this.props
      .dispatch(ContentQuestionAction.exportQuestionList(this.state.filterData))
      .then(() => {
        showExportCSVSuccessMessage();
      });
    this.setState({ showExportModal: false });
  }

  dismissMessage() {
    this.setState({ isAllowShowSearchMessage: false });
  }

  handleMouseEnter(index) {
    this.setState({
      hoverIndex: index,
    });
  }

  handleMouseLeave() {
    this.setState({
      hoverIndex: undefined,
    });
  }

  addAttribute() {
    let number = this.state.number;
    number++;
    this.setState({
      ...this.state,
      number,
    });
  }

  removeAttributeSearch(name) {
    const { formValues } = this.props;
    let attributeText = {};
    let attributeOptions = {};
    if (formValues && formValues.attributeText) {
      attributeText = formValues.attributeText;
    }
    if (formValues && formValues.attributeOptions) {
      attributeOptions = formValues.attributeOptions;
    }
    const attrArray = Object.keys(attributeOptions);
    const nameOptions = name.split('.').pop();
    const attrIndex = attrArray.indexOf(nameOptions);
    let number = this.state.number;
    attrArray.forEach((element) => {
      const indexElement = attrArray.indexOf(element);
      if (attrIndex === indexElement) {
        for (let i = attrIndex; i < number; i++) {
          const posDelete = attrArray[i];
          const posNext = attrArray[i + 1];
          attributeOptions[posDelete] = attributeOptions[posNext];
          this.props.dispatch(
            change('contentQuestionList', `attributeText.${posDelete}`, attributeText[posNext]),
          );
          // Reset value of last item to empty
          const lastElement = attrArray[NUM_ATTRIBUTE_QUESTION_SEARCH_MAX - 1];
          if (i === NUM_ATTRIBUTE_QUESTION_SEARCH_MAX - 1) {
            attributeOptions[lastElement] = '';
            this.props.dispatch(
              change('contentQuestionList', `attributeText.${lastElement}`, ''),
            );
          }
        }
      }
    });
    number--;
    this.setState({
      ...this.state,
      number,
    });
  }

  render() {
    const {
      questions,
      contentQuestionList,
      invalid,
      formValues,
      attributeOptions,
      attributeText,
      attributeListData,
      authCd,
      institutionId,
    } = this.props;
    const { hoverIndex } = this.state;
    return (
      <div>
        <MessageSearch
          recordNum={questions.recordNum}
          resultList={questions ? questions.allSecernIds : []}
          isAllowShowSearchMessage={this.state.isAllowShowSearchMessage}
          dismissMessage={this.dismissMessage}
        />
        <Col sm={12} className="float-end padding-left-right-clear align-right">
          <CustomLink
            className="margin-right-7 link-authority bold inline-flex line-height-20"
            to={Path.CONTENT_QUESTION_ATTRIBUTE_LIST}
            text="問題属性"
          />
        </Col>
        <ContentQuestionSearch
          {...this.state.filterData}
          onInputChange={this.handleInputChange}
          onSearchBtnClick={this.clickSearchButton}
          openExportDialog={this.openExportDialog.bind(this, MessageTemplate.BULK_EXPORT, null)}
          openOrCloseAttributeArea={this.openOrCloseAttributeArea}
          isClosed={this.state.isClosed}
          handleChangeOption={this.handleChangeOption}
          attributeOptions={attributeOptions}
          attributeText={attributeText}
          attributeListData={attributeListData}
          buttonText={this.state.buttonText}
          openPreviewEachQuestionAttribute={this.openPreviewEachQuestionAttribute}
          addAttribute={this.addAttribute}
          number={this.state.number}
          removeAttributeSearch={this.removeAttributeSearch}
        />
        <ContentQuestionList
          questions={questions}
          handleSortState={this.handleSortState}
          goToDetail={this.goToDetail}
          invalid={invalid}
          authCd={authCd}
          institutionId={institutionId}
          recordNum={questions.recordNum}
          startPosition={this.state.startPosition}
          getStartEndData={this.getStartEndData}
          handleMouseEnter={this.handleMouseEnter}
          handleMouseLeave={this.handleMouseLeave}
          hoverIndex={hoverIndex}
        />
        <DialogConfirm
          showModal={this.state.showExportModal}
          onCancel={this.onExportDialogCancel}
          mdSize={this.mdSize}
          content={this.content}
          onOK={this.onExportDialogOk}
        />
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const { questions, filterData, attributeListData } = state.question;
  const { contentQuestionList } = state.form;
  const { parentPath, searchCondition } = state.page;
  const invalid = isInvalid('contentQuestionList')(state);
  const { authedUser } = state.authed;
  const institutionId = (authedUser && authedUser.institutionId) ? authedUser.institutionId : '';
  const authCd = (authedUser && authedUser.authCd) ? authedUser.authCd : '';
  let initial = filterData;
  if (parentPath === CONTENT_QUESTION_LIST) {
    const paramSearch = {};
    if (searchCondition) {
      paramSearch.questionSecernId = searchCondition.questionSecernId;
      paramSearch.questionTitle = searchCondition.questionTitle;
      paramSearch.answerFormula = searchCondition.answerFormula;
      paramSearch.convertStatus = searchCondition.convertStatus;
      paramSearch.createdDateFrom = searchCondition.createdDateFrom;
      paramSearch.createdDateTo = searchCondition.createdDateTo;
      paramSearch.dataAffiliationType = searchCondition.dataAffiliationType;
      paramSearch.questionKind = searchCondition.questionKind;
      paramSearch.questionSortType = searchCondition.questionSortType;
      paramSearch.ascendingDescendingSort = searchCondition.ascendingDescendingSort;
      paramSearch.startPosition = searchCondition.startPosition;
      paramSearch.attributeOptions = searchCondition.attributeOptions;
      paramSearch.attributeText = searchCondition.attributeText;
      paramSearch.createdUserName = searchCondition.createdUserName; // Step 9.0.0
    }
    initial = paramSearch;
  }
  return {
    ...{ questions },
    ...{ contentQuestionList },
    initialValues: initial,
    invalid,
    attributeListData,
    formValues: getFormValues('contentQuestionList')(state),
    searchCondition,
    attributeOptions: formValueSelector('contentQuestionList')(state, 'attributeOptions'),
    attributeText: formValueSelector('contentQuestionList')(state, 'attributeText'),
    authCd,
    institutionId,
  };
};

export default connect(mapStateToProps)(
  reduxForm({
    form: 'contentQuestionList', // a unique identifier for this form
    touchOnChange: true,
    enableReinitialize: true,
  })(ContentQuestionListContainer),
);
